import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';


const LeaderboardIndividual = ( { aid, meta, user, viewing, canExport, contacts, opps, loans, start, end } ) => {
    const [ colsSource, setColsSource ] = useState( [
        { field: 'rank', headerName: 'Rank', width: 40, type: 'number' },
        { field: 'source', headerName: 'Referrer', flex: 1, minWidth: 100, cellClassName: 'tf-metrics-grid-row-label' },
        { field: 'total', headerName: 'Total', flex: 1, minWidth: 75, type: 'number' },
        { field: 'perc', headerName: '% of Total', flex: 1, minWidth: 75, type: 'number', valueFormatter: ( params ) => {
            return Number( params.value * 100 ).toLocaleString() + '%';
        } }
    ] );
    const [ leads, setLeads ] = useState( { id: 'leads' } );
    const [ funded, setFunded ] = useState( { id: 'funded' } );
    
    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center w-100'>
                        <Col></Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    useEffect( () => {
        let refs = {};
        let total = 0;
        
        if ( opps ) {
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );

            Object.keys( opps ).forEach( loid => {
                const lo = opps[loid];
                if ( !viewing.includes( lo.aid ) ) {
                    return;
                }

                if ( lo.oppDate ) {
                    const od = new Date( lo.oppDate + 'T12:00:00.000' );
                    if ( od.getTime() >= sd.getTime() && od.getTime() <= ed.getTime() ) {
                        total++;
                        if ( lo.relationships?.length ) {
                            const c = contacts[lo.relationships[0].cid];
                            if ( c && c.referredById ) {
                                if ( !refs[c.referredById] ) {
                                    refs[c.referredById] = 0;
                                }
                                refs[c.referredById]++;
                            }
                        }
                    }
                }
            } );
        }

        let rows = [];
        Object.keys( refs ).forEach( ( cid ) => {
            const c = contacts[cid];
            if ( c ) {
                rows.push( { 
                    id: cid,
                    source: `${c.firstname} ${c.lastname}`,
                    total: refs[cid],
                    perc: refs[cid] / total
                } );
            }
        } );
        rows.sort( ( a, b ) => {
            return b.total - a.total;
        } );
        rows.forEach( ( r, idx ) => r['rank'] = idx + 1 );

        setLeads( rows );
    }, [ contacts, opps, start, end, viewing ] );

    useEffect( () => {
        let refs = {};
        let total = 0;

        if ( loans ) {
            const sd = new Date( start + 'T12:00:00.000' );
            const ed = new Date( end + 'T12:00:00.000' );

            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( !viewing.includes( l.aid ) ) {
                    return;
                }

                // Funded
                if ( l.fundedDate ) {
                    const fd = new Date( l.fundedDate.match( 'T' ) ? l.fundedDate : l.fundedDate + 'T12:00:00.000' );
                    if ( fd.getTime() >= sd.getTime() && fd.getTime() <= ed.getTime() ) {
                        total++;
                        if ( l.borrowers?.length ) {
                            const pri = l.borrowers.find( f => f.label === 'Primary' ) || l.borrowers[0];
                            const c = contacts[pri?.cid];
                            if ( c && c.referredById ) {
                                if ( !refs[c.referredById] ) {
                                    refs[c.referredById] = 0;
                                }
                                refs[c.referredById]++;
                            }
                        }
                    }
                }
            } );
        }

        let rows = [];
        Object.keys( refs ).forEach( ( cid ) => {
            const c = contacts[cid];
            if ( c ) {
                rows.push( { 
                    id: cid,
                    source: `${c.firstname} ${c.lastname}`,
                    total: refs[cid],
                    perc: refs[cid] / total
                } );
            }
        } );
        rows.sort( ( a, b ) => {
            return b.total - a.total;
        } );
        rows.forEach( ( r, idx ) => r['rank'] = idx + 1 );

        setFunded( rows );
    }, [ loans, contacts, start, end, viewing ] );

    return (
        <Container fluid>
            <Row xs={1} md={2} className="g-3">
                <Col className="p-2" style={{ minWidth: 0 }}>
                    <div className="mb-2">Leads by Individuals</div>
                    <div className="overflow-auto" style={{ height: 500, width: '100%', minWidth: 0 }}>
                        <DataGridPro
                        rows={leads}
                        columns={colsSource}
                        disableSelectionOnClick
                        hideFooter
                        rowHeight={40}
                        slots={{ toolbar }}
                        />
                    </div>
                </Col>

                <Col className="p-2" style={{ minWidth: 0 }}>
                    <div className="mb-2">Fundings by Individuals</div>
                    <div className="overflow-auto" style={{ height: 500, width: '100%', minWidth: 0 }}>
                        <DataGridPro
                        rows={funded}
                        columns={colsSource}
                        disableSelectionOnClick
                        hideFooter
                        rowHeight={40}
                        slots={{ toolbar }}
                        />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    meta: state.user.meta,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( LeaderboardIndividual );